import { useEffect, useRef } from "react";

import { useAnalyticsEvents } from "@atlaskit/analytics-next";
import Button from "@atlaskit/button";

import {
    jswInteractiveBoardAnalyticsPayload,
    TRACKING_EVENT_NAMES
} from "./constants/analytics";
import { Steps } from "./constants/ui";
import { useInteractiveBoardStore } from "./state";

export const CreateButton = () => {
    const [
        { messages, step, isCreateButtonFocused, isDemoComplete },
        { toggleTicketModalOpen, nextDemoStep }
    ] = useInteractiveBoardStore();
    const { create = "" } = messages;
    const { createAnalyticsEvent } = useAnalyticsEvents();
    const buttonRef = useRef<HTMLButtonElement>(null);

    useEffect(() => {
        if (isCreateButtonFocused && buttonRef.current) {
            buttonRef.current.focus();
        }
    }, [isCreateButtonFocused]);

    const clickHandler = () => {
        // Should only be clickable on first step.
        // Recommendation is to check for ability to click or not in function instead of disabling button.
        // https://atlassian.design/components/button/usage#accessibility

        if (isDemoComplete) {
            void toggleTicketModalOpen();
            createAnalyticsEvent({
                ...jswInteractiveBoardAnalyticsPayload,
                attributes: {
                    eventName:
                        TRACKING_EVENT_NAMES.jswInteractiveBoardIssueModalOpened,
                    isDemoComplete: isDemoComplete
                }
            }).fire();
            return;
        }

        if (step === Steps.CREATE_FIRST_STORY) {
            createAnalyticsEvent({
                ...jswInteractiveBoardAnalyticsPayload,
                attributes: {
                    eventName:
                        TRACKING_EVENT_NAMES.jswInteractiveBoardIssueModalOpened,
                    demoStep: step + 1 + "/7",
                    isDemoComplete: isDemoComplete
                }
            }).fire();

            void toggleTicketModalOpen();
            void nextDemoStep();
            return;
        }
    };

    return (
        <Button
            appearance="primary"
            onClick={clickHandler}
            ref={buttonRef}
            testId="create-button"
        >
            {create}
        </Button>
    );
};
